import { connect } from 'react-redux'
import reduxFormTouchOnsubmit from 'hocs/reduxFormTouchOnsubmit'
import { ButtonStack, Divider, Grid, Tooltip, Typography } from 'maple-storybook'
import { Field, reduxForm } from 'redux-form'

import { HIDE_MODAL } from 'actions/modal'
import { Button, ItemGrid } from 'components'
import { GREEN } from 'helpers/constants'

let CustomFieldsForm = ({
  fields,
  submitFormAndTouchAll,
  customTooltipText,
  closeModal,
  customNote,
  gridClasses = '',
  shouldDisplayOnlyOneField = false
}) => {
  const adjustedWidth = fields.length === 1 || shouldDisplayOnlyOneField ? 12 : 5

  return (
    <form onSubmit={submitFormAndTouchAll}>
      <Grid container lg={12} sm={12} md={12} className={gridClasses}>
        {fields.map((field, index) => (
          <ItemGrid key={index} xs={12} sm={12} md={adjustedWidth} lg={adjustedWidth} itemGridClasses="mb-1">
            <Field {...field} />
          </ItemGrid>
        ))}
        <Typography variant="text-sm" type="normal" color={GREEN}>
          {customNote}
        </Typography>
      </Grid>
      <Divider className="padding-inline margin-block" />
      <Grid container lg={12} sm={12} md={12}>
        <ButtonStack>
          <Button variant="secondaryGray" onClick={closeModal}>
            Cancel
          </Button>
          <Tooltip title={customTooltipText || ''} open={false} arrow placement="top">
            <Button type="submit" data-cy="create">
              Save
            </Button>
          </Tooltip>
        </ButtonStack>
      </Grid>
    </form>
  )
}

CustomFieldsForm = reduxForm({
  form: 'custom-fields-form',
  touchOnChange: true,
  enableReinitialize: true
})(reduxFormTouchOnsubmit(CustomFieldsForm))

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(HIDE_MODAL)
  }
}

export default connect(null, mapDispatchToProps)(CustomFieldsForm)
